module.exports = __webpack_public_path__ + "static/media/29ADMSPC8.32cfd865.jpg";